// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"DailySudoku_contentWrapper__Zi94u","adsMobileWrapper":"DailySudoku_adsMobileWrapper__4DECC"};